import React, { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRepositories } from '../hooks/useRepositories';
import { LoadingState } from './PageStates';

/**
 * A page that only makes sense signed in: a signed-out visit goes to sign-in,
 * which comes back here after.
 */
export default function SignInRequired({ children }: { children: ReactNode }) {
  const { session } = useRepositories();
  const { pathname, search } = useLocation();
  const signedIn = Boolean(session.current().user?.id);

  useEffect(() => {
    if (!signedIn) window.location.replace(session.signInUrl(pathname + search));
  }, [signedIn, session, pathname, search]);

  return signedIn ? <>{children}</> : <LoadingState label="Taking you to sign in" />;
}
